const EVENTS = {
    trocaEmpresaRepresentante: 'trocaEmpresaRepresentante',
    desligaModalSistema: 'desligaModalSistema',
    ligaModalSistema: 'ligaModalSistema',
    cliente:{
        limparDropdown: 'limparDropdown',
    }
}

const CLEAR_EVENTS = ['trocaEmpresaRepresentante', 'limparDropdown']

export {
    CLEAR_EVENTS
};

export default EVENTS;
